import { IDetailedProductResponse } from "api/interfaces/get-page-details/product-page.type";
import ProductContainerWrapper from "modules/product/ProductContainerWrapper";
import dynamic from "next/dynamic";
import { useState, useEffect } from "react";
import { getProductBySkuApi } from "../../api/product/getProductBySkuApi";
const NotFound = dynamic(
  () => import(/* webpackChunkName: "notfound" */"component/notfound/notfound.component"),
  { ssr: false },
);
function PartNumberPage(props: any) {
  const { sku } = props;
  const [pageResponse, setPageResponse] = useState<IDetailedProductResponse>({});
  const pageType = "PARTS_PRODUCT_PAGE";

  useEffect(() => {
    getProductBySkuApi(sku)
      .then((response) => {
        setPageResponse(response.data);
      });
  }, []);

  const data = pageResponse;

  if (data.errorMessage === "SKU_NOT_FOUND") {
    return <NotFound />;
  }

  if (data.product) {
    return (
      <ProductContainerWrapper
        actualResponse={data}
        {...{ staticContent: {}, pageType }}
      />

    );
  }

  return "loading...";
}

export default PartNumberPage;
